import React, { Component } from 'react';
export default class ComparisonKeyBox extends Component {
  render() {
    const { colour, opacity } = this.props;
    return (
      <span
        className='h-100 db ml1 mr1 ba'
        style={{
          height: '70%',
          width: '15px',
          backgroundColor: colour,
          opacity
        }}
      />
    );
  }
}